import { CollectionPaymentStatus, CollectionStatus } from 'api-client';
import { formatDate } from 'formatters';

import { StatusBadgeTone } from '../../../common/StatusBadge/statusBadgeVariants';

/**
 * Статусы реестра взыскания — свой маленький справочник, а не ProjectStatusBadge:
 * тот отображает ProjectStatus платформы, это совсем другой набор значений.
 */
export const getCollectionStatusTone = (status?: CollectionStatus): StatusBadgeTone => {
  switch (status) {
    case CollectionStatus.OPEN:
      return 'yellow';
    case CollectionStatus.CLOSED:
      return 'green';
    default:
      return 'muted';
  }
};

export const getCollectionStatusLabel = (status?: CollectionStatus): string => {
  switch (status) {
    case CollectionStatus.OPEN:
      return 'В работе';
    case CollectionStatus.CLOSED:
      return 'Завершено';
    default:
      return 'Нет данных';
  }
};

export const getPaymentStatusTone = (status?: CollectionPaymentStatus): StatusBadgeTone => {
  switch (status) {
    case CollectionPaymentStatus.PAID:
      return 'green';
    case CollectionPaymentStatus.PLANNED:
      return 'default';
    default:
      return 'muted';
  }
};

export const getPaymentStatusLabel = (status?: CollectionPaymentStatus): string => {
  switch (status) {
    case CollectionPaymentStatus.PAID:
      return 'Поступил';
    case CollectionPaymentStatus.PLANNED:
      return 'Запланирован';
    default:
      return '—';
  }
};

/**
 * Дата приходит как Y-m-d (а не ISO datetime, как в остальных моделях), поэтому нужна
 * обёртка: formatDate ждёт Date.
 */
export const formatCollectionDate = (date?: string): string => {
  if (!date) {
    return '—';
  }

  const parsed = new Date(date);

  return Number.isNaN(parsed.getTime()) ? '—' : formatDate(parsed);
};
